export const TENANT_MODULE_CODES = Object.freeze([
  'core',
  'inventory',
  'food_service',
  'delivery',
  'finance',
  'people',
  'reports',
  'fiscal',
  'devices',
  'conecta',
  'wbuy',
  'correios'
]);

const TENANT_MODULE_CODE_SET = new Set(TENANT_MODULE_CODES);

export const ROUTE_MODULES = Object.freeze({
  '/produtos': 'inventory',
  '/tabelas-preco': 'inventory',
  '/categorias-produtos': 'inventory',
  '/inventario': 'inventory',
  '/fornecedores': 'inventory',
  '/ordens-compra': 'inventory',
  '/catalogo-operacional': 'inventory',

  '/mesas': 'food_service',
  '/comandas-mobile': 'food_service',

  '/entregas': 'delivery',
  '/entregadores': 'delivery',
  '/tabela-frete': 'delivery',

  '/financeiro': 'finance',
  '/financeiro-organizador': 'finance',
  '/dre': 'finance',
  '/financeiro-configuracoes': 'finance',
  '/crediario': 'finance',

  '/colaboradores': 'people',
  '/ponto': 'people',
  '/ponto-kiosk': 'people',
  '/agenda-comissoes': 'people',

  '/relatorios': 'reports',
  '/consultas': 'reports',
  '/inteligencia-publico': 'reports',

  '/fiscal': 'fiscal',
  '/espaco-contador': 'fiscal',
  '/nfe-mg': 'fiscal',
  '/nfse-itabira': 'fiscal',

  '/dispositivos': 'devices',
  '/conecta-clube': 'conecta',
  '/autorizar-conecta': 'conecta',
  '/wbuy': 'wbuy',
  '/correios': 'correios',
  '/pagarme': 'finance'
});

function objectValue(value) {
  if (value && typeof value === 'object' && !Array.isArray(value)) return value;
  if (typeof value !== 'string' || !value.trim()) return null;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
  } catch (_error) {
    return null;
  }
}

export function normalizeTenantModules(value, { legacyDefault = true } = {}) {
  const supplied = objectValue(value);
  const modules = {};
  for (const code of TENANT_MODULE_CODES) {
    if (code === 'core') {
      modules[code] = true;
    } else if (supplied) {
      modules[code] = supplied[code] === true || supplied[code] === 1;
    } else {
      modules[code] = legacyDefault === true;
    }
  }
  return modules;
}

export function tenantModulesFromUser(user) {
  const supplied = objectValue(
    user?.tenant_modules
      ?? user?.tenantModules
      ?? user?.modules
      ?? user?.tenant?.modules
  );
  return {
    hasSnapshot: Boolean(supplied),
    modules: normalizeTenantModules(supplied, { legacyDefault: true })
  };
}

export function tenantModulesVersionFromUser(user) {
  const parsed = Number(
    user?.tenant_modules_version
      ?? user?.tenantModulesVersion
      ?? user?.modulesVersion
      ?? user?.tenant?.modulesVersion
  );
  return Number.isSafeInteger(parsed) && parsed >= 1 ? parsed : 1;
}

export function moduleForPath(path) {
  const normalized = String(path || '/').split('?')[0].replace(/\/+$/, '') || '/';
  return ROUTE_MODULES[normalized] || 'core';
}

export function isTenantModuleEnabled(user, moduleCode) {
  const code = String(moduleCode || 'core').trim().toLowerCase();
  if (code === 'core') return true;
  if (!TENANT_MODULE_CODE_SET.has(code)) return false;
  return tenantModulesFromUser(user).modules[code] === true;
}

export function tenantEntitlementsFromActor(actor) {
  const tenant = actor?.tenant || {};
  const modules = normalizeTenantModules(tenant.modules, { legacyDefault: false });
  const modulesVersion = Number(tenant.modulesVersion);
  return {
    modules,
    modulesVersion: Number.isSafeInteger(modulesVersion) && modulesVersion >= 1 ? modulesVersion : 1
  };
}
